// Generated types for Workspace
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SecurityScopeReadAPI, SecurityScopeWriteAPI } from '../../shared/types/securityscope';
import { SecurityScopeReadAPISchemaObject, SecurityScopeWriteAPISchemaObject } from '../../shared/types/securityscope';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface WorkspaceReadAPI extends SecurityScopeReadAPI {
  /** The name of the project */
  name?: string;
}

export interface WorkspaceWriteAPI extends SecurityScopeWriteAPI {
  /** The name of the project */
  name?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const WorkspaceReadAPISchema: z.ZodType<WorkspaceReadAPI> = SecurityScopeReadAPISchemaObject.extend({
  name: z.string().optional(),
}).passthrough();

export const WorkspaceWriteAPISchema: z.ZodType<WorkspaceWriteAPI> = SecurityScopeWriteAPISchemaObject.extend({
  name: z.string().optional(),
}).passthrough();
